import Base from './base';

class GoogleAnalyticsPromotionalMaterialEvent extends Base {
  clickButton(filename: string) {
    this.sendEvent({
      category: 'promotional_material',
      action: 'click_button',
      label: filename,
      nonInteraction: false
    });
  }
}

export default new GoogleAnalyticsPromotionalMaterialEvent();
